import { useMemo } from 'react';
import { useOneDimension } from '~/app/shared/dimensions/hooks/useDimensions';

interface Props {
    dimensionId: number;
    includeDistributionKeys?: boolean;
    includeBarredLines?: boolean;
    hideInlineSearch?: boolean;
    hideSummary?: boolean;
}
export const useDimensionComboboxData = ({
    dimensionId,
    includeDistributionKeys = true,
    includeBarredLines = false,
    hideInlineSearch = false,
    hideSummary = false,
}: Props) => {
    const query = useOneDimension(dimensionId, { includeDistributionKeys, includeBarredLines });

    const data = useMemo(() => {
        if (query.loading) return [];

        return query?.data?.lines?.map(line => ({
            data: line,
            text: hideInlineSearch ? '' : `${line.key} - ${line.name}`,
            summary: hideSummary ? '' : line.name,
            value: line.key,
        }));
    }, [query.data?.lines, query.loading, hideInlineSearch, hideSummary]);

    return [query, data] as const;
};
